import styled from "styled-components";
import { Button } from "primereact/button";

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  /* Use your CSS variables for background and text colors */
  background: var(--bg-main);
  color: var(--text-main);
  position: relative;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("/path-to-stars-background.png");
    background-size: cover;
    opacity: 0.1;
    pointer-events: none;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;

  /* Use your CSS variables for background and text */
  background: var(--bg-card);
  color: var(--text-main);

  border-radius: 16px;
  padding: 3rem 4rem;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  text-align: center;
  max-width: ${({ width }) => width || "400px"};
  width: ${({ width }) => (width === "fit-content" ? "fit-content" : "100%")};

  @media (min-width: 480px) {
    width: ${({ width }) => (width === "fit-content" ? "fit-content" : "100%")};
  }
`;
